/**
 * Tache 1165 (Eric 2026-06-17) — Repli des accents, une seule fois.
 *
 * « interet » doit trouver « intérêt », et l'inverse. Le repli vit ici, et
 * nulle part ailleurs : la tache 1157 a montre ce que coutent deux copies
 * d'une meme regle (le tri n'avait ete corrige que d'un cote).
 *
 * `foldWithMap` sert au surlignage : il rend la chaine replie ET la
 * correspondance position par position avec le texte d'origine, pour
 * surligner la tranche exacte du texte affiche (accents compris).
 */

const COMBINING = /[\u0300-\u036f]/g;

/** Minuscules, accents retires. Pour filtrer. */
export const foldAccents = (text) =>
  String(text ?? "")
    .normalize("NFD")
    .replace(COMBINING, "")
    .toLowerCase();

/** Le texte contient-il la requete, accents et casse ignores ? */
export const foldedIncludes = (text, query) => {
  const needle = foldAccents(query).trim();
  if (!needle) return true;
  return foldAccents(text).includes(needle);
};

/**
 * { folded, map, chars } : `map[i]` donne l'index, dans `chars`, du caractere
 * d'origine qui a produit `folded[i]`. Les marques combinantes isolees ne
 * produisent rien : elles sont rattachees au caractere precedent.
 */
export const foldWithMap = (text) => {
  const chars = [...String(text ?? "")];
  const folded = [];
  const map = [];
  chars.forEach((ch, index) => {
    const piece = ch.normalize("NFD").replace(COMBINING, "").toLowerCase();
    for (const c of piece) {
      folded.push(c);
      map.push(index);
    }
  });
  return { folded: folded.join(""), map, chars };
};

export default foldAccents;
